import MeetingInterfaceEditable from "./meeting-details-editable";

export default function Review({setSidebar,meetingId}:any) {
    return <>
        <MeetingInterfaceEditable setSidebar={setSidebar} meetingId={meetingId}/>
    </>
}